import { sum } from "@pentacode/openapi";
import { NominalHoursMode } from "./model";
import { toDateString } from "./utils";
import { isDateInRange } from "./utils/date.util";
export function getDefaultSalary(salaries) {
    return salaries.find((s) => s.positionId === null);
}
export function hasFixedWorkDays(mode) {
    return [NominalHoursMode.FixedDays, NominalHoursMode.FixedDaysWithoutHolidays].includes(mode);
}
export function getNominalWeeklyHours(props) {
    return hasFixedWorkDays(props.nominalHoursMode)
        ? sum(...(props.hoursPerDay || []))
        : props.hoursPerWeek || 0;
}
export function getSalaryOrDefault(positionId, salaries) {
    // Try to find position-specific salary first
    return (salaries.find((salary) => salary.positionId === positionId) ||
        // Otherwise choose default salary (no position attached)
        getDefaultSalary(salaries));
}
export function isActiveOn(date, range) {
    return range.start <= date && (!range.end || range.end > date);
}
/**
 * Gets the current active contract for the given date (default: today)
 */
export function getCurrentContract(contracts) {
    const today = toDateString(new Date());
    return contracts.find((contract) => contract.start <= today && (!contract.end || contract.end > today)) || null;
}
/**
 * Gets the first contract by start date
 */
export function getFirstContract(contracts) {
    return contracts.sort((a, b) => (a.start < b.start ? -1 : 1))[0] || null;
}
/**
 * Gets the latest contract by end date (contracts without end date are considered latest)
 */
export function getLatestContract(contracts) {
    return contracts.sort((a, b) => (!a.end ? -1 : !b.end ? 1 : a.end > b.end ? -1 : 1))[0] || null;
}
/**
 * Gets contract deadline events (probation end, contract end) within the given date range.
 *
 * @param employees - Array of employees with contracts
 * @param dateRange - The date range to check for deadlines (from is inclusive, to is exclusive)
 * @returns Array of contract deadline events sorted by date
 */
export function getContractDeadlineEvents(employees, dateRange) {
    return employees
        .filter((employee) => employee.contracts.length > 0)
        .flatMap((employee) => {
        const events = [];
        const currentContract = getCurrentContract(employee.contracts);
        if (!currentContract) {
            return events;
        }
        if (currentContract.end && isDateInRange(currentContract.end, dateRange)) {
            events.push({
                type: "contractEnd",
                employee,
                contract: currentContract,
                date: currentContract.end,
            });
        }
        if (currentContract.probationEnd && isDateInRange(currentContract.probationEnd, dateRange)) {
            events.push({
                type: "probationEnd",
                employee,
                contract: currentContract,
                date: currentContract.probationEnd,
            });
        }
        return events;
    })
        .sort((a, b) => {
        if (!a.date || !b.date)
            return 0;
        return a.date < b.date ? -1 : a.date > b.date ? 1 : 0;
    });
}
//# sourceMappingURL=contract.util.js.map